import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogConfig } from '@angular/material';
import { ApplicationStateService } from '../../../services/application-state.service';
import { DialogAction } from '../dialogs-configuration';
import { DialogComponentInterface } from '../dialog-component.interface';
import { DialogConfigBase } from '../dialog-config-base';
import { DialogConfigInterface } from '../dialog-config.interface';

@Component({
  selector: 'app-loading-offers-dialog',
  templateUrl: './loading-offers-dialog.component.html'
})
export class LoadingOffersDialogComponent implements OnInit, DialogComponentInterface {

  static getConfigBuilder(): any {
    return new LoadingOffersDialogConfig();
  }

  constructor(@Inject(MAT_DIALOG_DATA) public data: LoadingOffersDialogData,
              private stateService: ApplicationStateService) {
  }

  get displayedOffersNumber(): number {
    return this.stateService.displayedOffersNumber;
  }

  get progressBarValue(): number {
    return this.stateService.foundOffersPercent;
  }

  ngOnInit() {
  }

}

export class LoadingOffersDialogConfig extends DialogConfigBase implements DialogConfigInterface {
  private config: MatDialogConfig = {
    panelClass: 'app-dialog',
    disableClose: true
  };

  constructor() {
    super();
  }

  buildConfiguration(data: LoadingOffersDialogData): MatDialogConfig {
    return this.buildConfig(data, this.config);
  }
}

export interface LoadingOffersDialogData {
  header: string,
  imageSrc: string,
  offersMessage: string,
  analysisMessage: string,
  displayTime: number,
  actionText: string,
  actionKey: DialogAction,
  canCloseOnNavigation?: boolean
}
